module.exports = __webpack_public_path__ + "assets/img/overtime.4ffe071c.png";